module.exports = __webpack_public_path__ + "img/fb.fe6375d3.png";